

/// <reference path="RuleSet.ts" />

// Generated class RuleSetGuard_ManagedObject

class RuleSetGuard_ManagedObject extends RuleSet
{
}
